module.exports = __webpack_public_path__ + "static/intro_lo-ca5fcb1e505667c018af0f619ec3803b.mp4";